var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11194",
    "data-name": "Group 11194",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.83,
    height: 11.306,
    viewBox: "0 0 15.83 11.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4102",
    "data-name": "Rectangle 4102",
    width: 15.83,
    height: 11.306,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11193",
    "data-name": "Group 11193",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M7.959,0h6.114a1.862,1.862,0,0,1,.533.062A1.677,1.677,0,0,1,15.3.468a1.626,1.626,0,0,1,.485.844,2,2,0,0,1,.045.42q0,3.94,0,7.88a1.7,1.7,0,0,1-.292.939,1.555,1.555,0,0,1-.7.6,1.674,1.674,0,0,1-.528.132c-.164.013-.329.018-.494.018H1.846a1.946,1.946,0,0,1-.662-.088A1.664,1.664,0,0,1,.035,9.885,2.2,2.2,0,0,1,0,9.481Q0,5.593,0,1.706A1.6,1.6,0,0,1,.242.816,1.641,1.641,0,0,1,1.415.034,3,3,0,0,1,1.846,0Q4.9,0,7.959,0M7.905,10.178h6.078c.047,0,.094,0,.141,0a.565.565,0,0,0,.546-.422,1.092,1.092,0,0,0,.029-.271q0-3.821,0-7.641c0-.044,0-.088,0-.132a.569.569,0,0,0-.427-.552,1.189,1.189,0,0,0-.28-.028q-6.1,0-12.19,0a1.161,1.161,0,0,0-.21.02.549.549,0,0,0-.442.438,1.838,1.838,0,0,0-.019.255q0,3.829,0,7.659a1.341,1.341,0,0,0,.017.2.548.548,0,0,0,.471.459,1.9,1.9,0,0,0,.237.016H7.905",
    transform: "translate(0 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M50.046,51.462c-.256,0-.512,0-.768,0a1.262,1.262,0,0,1-.442-.069,1.1,1.1,0,0,1-.735-.854,2.108,2.108,0,0,1-.032-.359q-.007-.459,0-.918a1.179,1.179,0,0,1,.135-.56,1.091,1.091,0,0,1,.914-.6c.149-.012.3-.014.449-.015.409,0,.818,0,1.227,0a1.43,1.43,0,0,1,.459.071,1.144,1.144,0,0,1,.746.973c.025.385.013.77.011,1.155a1.137,1.137,0,0,1-.138.576,1.171,1.171,0,0,1-.5.5.92.92,0,0,1-.366.088c-.32.013-.641.018-.961.026v-.008m-.856-1.124h1.693c.017-.1.014-1.062,0-1.13-.115-.017-1.627-.011-1.691.006Z",
    transform: "translate(-45.8 -45.816)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M49.759,157.125c-.353,0-.707,0-1.06,0a.816.816,0,0,1-.2-.023.565.565,0,0,1-.436-.58.518.518,0,0,1,.45-.5,1.3,1.3,0,0,1,.21-.02q1.047,0,2.093,0a.946.946,0,0,1,.218.027.537.537,0,0,1,.414.483.562.562,0,0,1-.354.566.739.739,0,0,1-.275.052h-1.06",
    transform: "translate(-45.798 -148.647)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M133.739,157.125c-.353,0-.707,0-1.06,0a.883.883,0,0,1-.218-.027.564.564,0,0,1-.425-.562.527.527,0,0,1,.455-.518,1.394,1.394,0,0,1,.228-.019q1.033,0,2.067,0a.96.96,0,0,1,.218.025.539.539,0,0,1,.419.488.563.563,0,0,1-.358.563.739.739,0,0,1-.267.051h-1.06",
    transform: "translate(-125.815 -148.646)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M217.751,157.12c-.353,0-.707,0-1.06,0a.859.859,0,0,1-.243-.037.561.561,0,0,1-.212-.942.381.381,0,0,1,.182-.1,1.558,1.558,0,0,1,.287-.043q1.06-.005,2.12,0a.9.9,0,0,1,.209.028.539.539,0,0,1,.411.485.564.564,0,0,1-.358.563.737.737,0,0,1-.267.051h-1.069",
    transform: "translate(-205.878 -148.642)",
    fill: "#393939"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditIcon);
export default __webpack_public_path__ + "static/media/credit-icon.eda15af290db82bfff6cd61283c5999d.svg";
export { ForwardRef as ReactComponent };